import { POSTAPI, generateHeader } from "../../../api-setup/api-helper";
import { GET_ALL_MOBILE_APPROVERS } from "../../../api-setup/api-endpoints";

export const fetchApproverDetails = async (cookiesData, dispatch, contractId) => {
  try {
    const apiHeaders = generateHeader();

    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter: "",
      in_sort_number: 2,
      in_sort_order: "ASC",
    };

    const response = await POSTAPI(false, GET_ALL_MOBILE_APPROVERS, null, apiHeaders, requestBody, dispatch);

    if (response?.data?.row_result && Array.isArray(response.data.row_result)) {
      const rawData = response.data.row_result;

      // Transform the data to dropdown format with id and text properties
      // Using user_key as id and combining user_first_name + user_last_name as text
      const transformedData = rawData.map((approver) => {
        const fullName = `${approver.user_first_name || ""} ${approver.user_last_name || ""}`.trim();
        const displayText = fullName || approver.user_username || approver.user_email || "Unknown";

        return {
          id: approver.user_key,
          text: displayText,
        };
      });

      return {
        success: true,
        approverDetailsData: rawData,
        transformedData: transformedData,
        count: transformedData.length,
      };
    } else {
      console.error("Failed to fetch approver details:", response?.message || "Invalid response structure");
      return {
        success: false,
        approverDetailsData: [],
        transformedData: [],
        count: 0,
        error: response?.message || "Invalid response structure",
      };
    }
  } catch (error) {
    console.error("Error fetching all mobile approvers:", error);
    return {
      success: false,
      approverDetailsData: [],
      transformedData: [],
      count: 0,
      error: error.message,
    };
  }
};
